import { render, staticRenderFns } from "./AccountBalance.html?vue&type=template&id=57863c81&scoped=true&"
import script from "./AccountBalance.ts?vue&type=script&lang=ts&"
export * from "./AccountBalance.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_balance.scss?vue&type=style&index=0&id=57863c81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57863c81",
  null
  
)

export default component.exports